<template>
  <div class="documentation">
    <Breadcumb title="Ajouter une question" :breadcumb-data="breadcumbData"></Breadcumb>
    <b-form @submit="addQuestion" class="cardcontainer">
      <form-wizard class="form-wizard-boxed-steps">
        <!-- Allow html in tab title (this template required for the proper styling) -->
        <template slot="step" slot-scope="props">
          <wizard-step :tab="props.tab" @click.native="props.navigateToTab(props.index)" @keyup.enter.native="props.navigateToTab(props.index)" :transition="props.transition" :index="props.index">
            <span slot="title" :class="{'text-danger':props.tab.validationError}" v-html="props.tab.title"></span>
          </wizard-step>
        </template>
        <tab-content title="<div class='small text-muted'>Etape 1</div>Paramètres généraux">
          <b-card>
            <b-form-group label="Type de question" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-select value="Choisir une catégorie de document" v-model="type" :options="typeData" @change="changeType($event)"/>
              <b-alert  v-if="errors['type']" show variant="danger">
                {{ errors['type'][0] }}
              </b-alert>
            </b-form-group>
            <b-form-group label="Tag" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-check-group v-model="tags" :options="tagData"/>
              <b-alert  v-if="errors['tags']" show variant="danger">
                {{ errors['tags'][0] }}
              </b-alert>
            </b-form-group>
          </b-card>
        </tab-content>
        <tab-content title="<div class='small text-muted'>Etape 2</div>Traductions">
          <b-card v-for="traduction in qtraductions" class="mb-2">
            <b-form-group label="Language" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-select value="fr" v-model="traduction.language" :options="languageData"/>
              <b-alert  v-if="errors['type']" show variant="danger">
                {{ errors['type'][0] }}
              </b-alert>
            </b-form-group>
            <b-form-group label="Question" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-input type="text" placeholder="Label" v-model="traduction.label"/>
              <b-alert  v-if="errors['label']" show variant="danger">
                {{ errors['label'][0] }}
              </b-alert>
            </b-form-group>
            <b-form-group v-if="type !== 'TFREE'" label="Réponses" label-align-md="right"
                          label-class="pr-md-2" :label-cols-md="2">
              <b-alert  v-if="answers_err" show variant="danger">
                {{ answers_err }}
              </b-alert>
              <b-form-row v-for="question in traduction.answers" v-bind:key="question.value">
                <b-form-group>
                  <b-input type="text" placeholder="Valeur de la réponse" v-model="question.value"/>
                </b-form-group>
                <b-form-group class="ml-4">
                  <b-input type="text" placeholder="Texte de la réponse" v-model="question.label"/>
                </b-form-group>
              </b-form-row>
              <b-form-group>
                <b-btn v-on:click="addAnswer()" variant="success">
                  Ajouter une réponse
                </b-btn>
              </b-form-group>
            </b-form-group>
          </b-card>
        </tab-content>
        <b-btn variant="default" slot="prev">Retour</b-btn>
        <b-btn variant="default" slot="next">Suivant</b-btn>
        <b-btn variant="warning" v-on:click="addTranslation" slot="finish">Ajouter une traduction</b-btn>
        <b-btn type="submit" variant="primary" slot="finish">Modifier la question</b-btn>
      </form-wizard>
    </b-form>
  </div>
</template>
<style src="@/vendor/libs/vue-form-wizard/vue-form-wizard.scss" lang="scss"></style>
<script>
  import {
    ADMIN_GET_QUESTION_REQUEST, ADMIN_GET_TAGS_REQUEST, ADMIN_UPDATE_QUESTION_REQUEST
  } from '../../_store/administration/questionnary/actiontypes'
  import { mapState } from 'vuex';
  import Breadcumb from '../../components/breadcumb';
  import {GET_LANGUAGES_REQUEST} from "../../_store/translation/actiontypes";
  import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'

  export default {
    name: 'adminCategoryAdd',
    components: {Breadcumb, FormWizard, TabContent, WizardStep},
    mounted() {
      this.$store.dispatch(ADMIN_GET_QUESTION_REQUEST, this.$route.params.id)
        .then(response => {
          this.tags = response.data.question.tags.map(tag => {
            return tag.id;
          })
          this.qtraductions = response.data.question.qtranslations.map(translation => {
            translation.language = translation.language.id;
            return translation
          })
          this.source = response.data.question.source;
          this.type = response.data.question.type;
          this.is_mandatory = response.data.question.is_mandatory;
          this.question_id = response.data.question.id;
        });
      this.$store.dispatch(ADMIN_GET_TAGS_REQUEST)
              .then(response => {
                this.tagData = response.data.tags.map(tag => {
                  return {
                    value: tag.id,
                    text: tag.label
                  }
                })
              })
      this.$store.dispatch(GET_LANGUAGES_REQUEST)
              .then(response => {
                this.languageData = response.data.languages.map(item => {
                  return {
                    "value": item.id,
                    "text": item.name
                  }
                })
              })
    },
    computed: mapState({ errors: state => state.admin_questionnary.errors }),
    data() {
      return ({
        question_id: null,
        languageData : [],
        qtraductions: [{
          language: 1,
          answers: [],
          label: "",
        },
          {
            language: 2,
            answers: [],
            label: "",
          }
        ],
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des questions', href: '/dashboard/administration/questionnary/' },
          { text: 'Ajouter une question', active: true },
        ],
        answers_err : '',
        label_en: '',
        label: '',
        is_mandatory: false,
        tagData: [],
        tags: [],
        answers: [
          {
            value: '',
            text: '',
            text_en: ''
          }
        ],
        type: 'TSING',
        typeData: [
          {
            value: 'YESNO',
            text: 'Oui / non'
          },
          {
            value: 'FOURANSWERS',
            text: '4 modalités'
          },
          {
            value: 'ONETOTEN',
            text: '1 à 10'
          },
          {
            value: 'TFREE',
            text: 'Réponse libre'
          }, {
            value: 'TSING',
            text: 'Choix Unique'
          }, {
            value: 'TMULT',
            text: 'Choix Multiple'
          }
        ]
      })
    },
    layout(context) {
      return 'layout'
    },
    methods: {
      addTranslation: function() {
        let answers = this.qtraductions[0].answers;
        this.qtraductions.push({
          language: 0,
          answers: answers.map(answer => {
            answer.text = '';
            return answer;
          }),
          label: ""
        });
      },
      changeType: function(e) {
        this.qtraductions = this.qtraductions.map(traduction => {
          if (this.type === 'YESNO') {
            if (traduction.language == 1) {
              traduction.answers = [
                {value: 'no', label: 'Non'},
                {value: 'yes', label: 'Oui'},
              ]
            } else if (traduction.language == 2) {
              traduction.answers = [
                {value: 'no', label: 'No'},
                {value: 'yes', label: 'Yes'},
              ]
            }
          }
          else if (this.type === 'FOURANSWERS') {
            if (traduction.language == 1) {
              traduction.answers = [
                {value: '1', label: 'Tout à fait d\'accord'},
                {value: '2', label: 'Plutôt d\'accord'},
                {value: '3', label: 'Plutôt pas d\'accord'},
                {value: '4', label: 'Pas du tout d\'accord'},
                {value: '5', label: 'Non concerné.e / ne sais pas'},
              ]
            } else if (traduction.language == 2) {
              traduction.answers = [
                {value: '1', label: 'Strongly agree'},
                {value: '2', label: 'Agree'},
                {value: '3', label: 'Disagree'},
                {value: '4', label: 'Strongly Disagree'},
                {value: '5', label: 'Not affected / don’t know'},
              ]
            }

          }
          else if (this.type === 'ONETOTEN') {
            traduction.answers = [
              {value: '1', label: '1'},
              {value: '2', label: '2'},
              {value: '3', label: '3'},
              {value: '4', label: '4'},
              {value: '5', label: '5'},
              {value: '6', label: '6'},
              {value: '7', label: '7'},
              {value: '8', label: '8'},
              {value: '9', label: '9'},
              {value: '10', label: '10'},
            ]
          }
          return traduction;
        });
      },
      addQuestion: function(e) {
        e.preventDefault();
        if (this.type === 'YESNO') {
          this.type = 'TSING';
        }
        else if (this.type === 'FOURANSWERS') {
          this.type = 'TSING';
        }
        else if (this.type === 'ONETOTEN') {
          this.type = 'TSING';
        }
        this.$store.dispatch(ADMIN_UPDATE_QUESTION_REQUEST, {
          tags: this.tags,
          qtranslations: this.qtraductions,
          type: this.type,
          source: this.source,
          is_mandatory: this.is_mandatory,
          id: this.question_id
        })
                .then(() => {
                  this.$router.push('/dashboard/administration/questionnary/');
                })
                .catch((error) => {
                  console.log('error is ==');
                  console.log(error);
                });

      },
      addAnswer: function() {
        this.qtraductions = this.qtraductions.map(translation => {
          translation.answers.push({
            value: '',
            label: ''
          })
          return translation;
        });
      }
    }
  }
</script>
